import * as Sentry from '@sentry/react';
import HyperDX from '@hyperdx/browser';

// Initialize HyperDX with environment variable control
const isProduction = process.env.REACT_APP_ENV === 'prod' || process.env.NODE_ENV === 'production';
const isHyperDXExplicitlyEnabled = process.env.REACT_APP_HYPERDX_ENABLED === 'true';
const isHyperDXExplicitlyDisabled = process.env.REACT_APP_HYPERDX_ENABLED === 'false';
const shouldInitializeHyperDX = !isHyperDXExplicitlyDisabled && (isProduction || isHyperDXExplicitlyEnabled) && process.env.REACT_APP_HYPERDX_API_KEY;

if (shouldInitializeHyperDX && process.env.REACT_APP_HYPERDX_API_KEY) {
	console.log('🔍 HyperDX monitoring initialized for environment:', process.env.REACT_APP_ENV || 'development');
	
	HyperDX.init({
		apiKey: process.env.REACT_APP_HYPERDX_API_KEY,
		service: `telagri-frontend-${process.env.REACT_APP_ENV || 'dev'}`,
		tracePropagationTargets: [
			// Add your API endpoints here
			new RegExp(process.env.REACT_APP_API_URL || 'localhost'),
		],
		// Performance optimization: Disable console capture completely for better performance
		consoleCapture: false, // Disable automatic console capture to reduce performance impact
		advancedNetworkCapture: false, // Disable advanced network capture for better performance
		maskAllInputs: false, // Better privacy
		maskAllText: false,
	});
} else if (isHyperDXExplicitlyDisabled) {
	console.log('🔍 HyperDX monitoring explicitly disabled via REACT_APP_HYPERDX_ENABLED=false');
} else {
	console.log('🔍 HyperDX monitoring disabled for local development');
}

if (process.env.REACT_APP_ENV === 'prod') {
	Sentry.init({
		dsn: process.env.REACT_APP_SENTRY_DSN,
		environment: process.env.REACT_APP_ENV,
		release: 'telagri_v1',
		integrations: [],
	});
}
